import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Input from "./Input"; // Assuming you have an Input component
import Button from "./Button"; // Assuming you have a Button component

const API_URL = process.env.REACT_APP_API_URL;

function TicketForm({ ticketList }) {
    const [formData, setFormData] = useState({ Placa: "" });

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            console.log(API_URL || "API URL not found :(");
            const url = `${API_URL}/set-ticket`;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log("Response:", result);

            if (response.ok) {
                toast.success(result.message, { autoClose: 2000 });

                // Optional: Clear form after successful submission
                setFormData({ Placa: "" });
            } else {
                toast.error(result.message || "Ticket creation failed", { autoClose: 3000 });
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred while inserting the ticket.", { autoClose: 3000 });
        }
    };

    return (
        <div className="p-3 justify-content-center">
            <div className="card m-3 p-3">
                <h2 className="text-center">Create Ticket</h2>
                <form onSubmit={handleSubmit}>
                    <Input
                        label="Placa"
                        type="text"
                        id="placa" 
                        placeholder="000-000"
                        value={formData.placa}
                        onChange={handleInputChange}
                    />
                    <div className="text-center">
                        <Button text="Create Ticket" />
                    </div>
                </form>
            </div>
            <ToastContainer />
        </div>
    );
}

export default TicketForm;
